import { Field, FieldProps } from "formik";
import * as React from "react";
import { Alert } from "react-bootstrap";
import { FFieldSelectI, OptionI } from "../../types";

export const FFieldSelect: React.FC<FFieldSelectI> = (props) => {
    const {
        formName,
        label,
        options,
        required,
        id,
        onBlur,
        onChange,
        tabIndex,
        autoFocus,
        labelAppend,
        className,
    } = props;

    return (
        <>
            {options ? (
                <Field name={formName}>
                    {({
                        field, // { name, value, onChange, onBlur }
                        form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                        meta,
                    }: FieldProps) => (
                        <>
                            <div className={`form-floating ${className}`}>
                                <select
                                    id={id ?? `f_${formName}`}
                                    className={"form-select"}
                                    name={field.name}
                                    value={field.value}
                                    onChange={(e) => {
                                        form.handleChange(formName)(e);

                                        if (onChange) {
                                            onChange(e.currentTarget.value);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        form.handleBlur(formName)(e);
                                        if (onBlur) {
                                            onBlur(field.value);
                                        }
                                    }}
                                    tabIndex={tabIndex}
                                    autoFocus={autoFocus}
                                    // {...field}
                                >
                                    {options.map((option: OptionI, index) => (
                                        <option
                                            key={`ffield-select-option-${option.label}`}
                                            value={option.value}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </select>

                                <label htmlFor={formName}>
                                    {required ? <sup>* </sup> : null}
                                    {label}
                                    {labelAppend === null ? (
                                        ""
                                    ) : labelAppend ? (
                                        <>{labelAppend}</>
                                    ) : (
                                        ":"
                                    )}
                                </label>
                            </div>

                            {meta.touched && meta.error && (
                                <Alert variant={"warning"} className={"mt-2"}>
                                    {meta.error}
                                </Alert>
                            )}
                        </>
                    )}
                </Field>
            ) : null}
        </>
    );
};
